import { convert } from '../utils'

let lines = [

  {text: ['加利“孩”尼亚的海大王们'],startTime: '00:00:01.00', endTime: '00:00:03.07'},
  {text: ['可喜欢人们来冲浪了'],startTime: '00:00:03.08', endTime: '00:00:05.21'},
  {text: ['尤其是在圣地亚哥的拉霍亚'],startTime: '00:00:05.22', endTime: '00:00:10.09'},
  {text: ['每次有人进入水中'],startTime: '00:00:10.10', endTime: '00:00:12.12'},
  {text: ['他们都要热闹地庆祝一番'],startTime: '00:00:12.13', endTime: '00:00:15.12'},
  {text: ['瞧 大灰鲸已经兴奋得喷出水柱'],startTime: '00:00:15.13', endTime: '00:00:19.11'},
  {text: ['连小鱼儿都忍不住'],startTime: '00:00:19.12', endTime: '00:00:21.12'},
  {text: ['跳出水来和游客们拍照'],startTime: '00:00:21.13', endTime: '00:00:23.23'},
  {text: ['它们居然带上了自拍杆'],startTime: '00:00:23.24', endTime: '00:00:26.10'},
  {text: ['真是太会玩啦'],startTime: '00:00:26.11', endTime: '00:00:28.09'},

]

export default convert(lines)

